var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"id":"chart"}},[_c('h1',[_vm._v(" Séances ")]),_c('div',{staticClass:"chart-wrapper"},[_c('apexchart',{attrs:{"width":"480","type":"line","options":_vm.options,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }